import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const SfStarIcon = (props: IconProps) => (
  <StyledIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5.83886 20.3291C5.6162 20.1592 5.48143 19.9336 5.43456 19.6523C5.38768 19.377 5.42577 19.0576 5.54882 18.6943L7.333 13.3945L2.78026 10.1338C2.46386 9.90527 2.2412 9.66797 2.11229 9.42188C1.98925 9.16992 1.9746 8.90918 2.06835 8.63965C2.15624 8.37598 2.32323 8.18262 2.56933 8.05957C2.81542 7.93066 3.13183 7.86621 3.51854 7.86621H9.10839L10.8047 2.56641C10.9219 2.19727 11.0801 1.91602 11.2793 1.72266C11.4785 1.52344 11.7158 1.42383 11.9912 1.42383C12.2725 1.42383 12.5127 1.52344 12.7119 1.72266C12.9111 1.91602 13.0693 2.19727 13.1865 2.56641L14.8828 7.86621H20.4639C20.8564 7.86621 21.1758 7.93066 21.4219 8.05957C21.668 8.18262 21.8349 8.37598 21.9228 8.63965C22.0166 8.90918 21.999 9.16992 21.8701 9.42188C21.7471 9.66797 21.5273 9.90527 21.2109 10.1338L16.6582 13.3945L18.4424 18.6943C18.5654 19.0576 18.6035 19.377 18.5566 19.6523C18.5098 19.9336 18.375 20.1592 18.1523 20.3291C17.9238 20.499 17.6689 20.5605 17.3877 20.5137C17.1123 20.4668 16.8193 20.3291 16.5088 20.1006L11.9912 16.7871L7.48241 20.1006C7.17186 20.3291 6.87597 20.4668 6.59472 20.5137C6.31933 20.5605 6.06737 20.499 5.83886 20.3291Z"
      fill="currentColor"
    />
  </StyledIcon>
)
